import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    browse: {
        id: "menu.browse",
    },
    editor: {
        id: "menu.editor",
    },
    homeworks: {
        id: "menu.homeworks",
    },
    homework: {
        id: "homework",
    },
    classes: {
        id: "dashboard.classes",
    },
    join: {
        id: "classroom",
    },
    moderation: {
        id: "menu.moderation",
    },
    registration: {
        id: "menu.registration",
    },
    login: {
        id: "menu.login",
    },
    logout: {
        id: "menu.logout",
    },
    account: {
        id: "menu.account",
    },
    help: {
        id: "help.title",
    },
    translate: {
        id: "menu.translate",
    },
    aboutUs: {
        id: "menu.aboutUs",
    },
    teachingSettings: {
        id: "teachingSettings.title",
    },
});

export default messages;
